import { useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function CommentForm({
  threadId,
  onAdded,
}: {
  threadId: string;
  onAdded: () => void;
}) {
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const text = body.trim();
    if (!text) return;

    setLoading(true);

    // 👇 User holen, für RLS (user_id = auth.uid())
    const {
      data: { user },
      error: authErr,
    } = await supabase.auth.getUser();

    if (authErr || !user) {
      alert("Bitte logge dich ein, um zu kommentieren.");
      setLoading(false);
      return;
    }

    // 👇 user_id mitsenden (erfüllt RLS with check)
    const { error } = await supabase.from("feedback_comments").insert([
      {
        thread_id: threadId,
        user_id: user.id,
        body: text,
      },
    ]);

    if (error) {
      console.error("❌ Kommentar speichern fehlgeschlagen:", error.message);
      alert("Kommentar konnte nicht gespeichert werden.");
    } else {
      setBody("");
      onAdded(); // Liste neu laden
    }

    setLoading(false);
  };

  return (
    <div className="mb-6">
      <textarea
        className="w-full border rounded-lg p-3 min-h-[80px] outline-none"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        placeholder="Dein Kommentar…"
        maxLength={4000}
      />
      <div className="mt-2 flex justify-end">
        <button
          onClick={submit}
          disabled={loading || !body.trim()}
          className={`px-4 py-2 rounded ${
            loading || !body.trim()
              ? "bg-gray-200 text-gray-500"
              : "bg-indigo-600 text-white hover:bg-indigo-700"
          }`}
        >
          {loading ? "Sende…" : "Senden"}
        </button>
      </div>
    </div>
  );
}
